import React from "react";

// 1. MEAL CARD SKELETON (SHIMMER EFFECT - MATCHES MINIMAL MEALCARD EXACTLY)
export function MealCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl border border-border-primary/80 p-5 flex flex-col justify-between">
      
      {/* Top Section */}
      <div className="flex gap-4 items-start">
        {/* Image Skeleton */}
        <div className="shimmer w-20 h-20 rounded-2xl shrink-0"></div>

        {/* Details Skeleton */}
        <div className="flex-1 space-y-2">
          <div className="shimmer h-4 rounded-md w-3/4"></div>
          <div className="shimmer h-3 rounded-md w-1/2"></div>
          <div className="shimmer h-3 rounded-md w-1/3"></div>
        </div>
      </div>

      {/* Badges & Actions row */}
      <div className="flex items-center justify-between gap-3 mt-4 pt-1 w-full">
        {/* Badges block */}
        <div className="flex items-center gap-2">
          <div className="shimmer h-6 rounded-lg w-14"></div>
          <div className="shimmer h-6 rounded-lg w-14"></div>
        </div>

        {/* Actions block */}
        <div className="shimmer h-6 rounded-lg w-20"></div>
      </div>

      {/* Divider & Add-ons block */}
      <div className="border-t border-border-primary/50 my-4" />
      
      <div>
        <div className="shimmer h-3 rounded-md w-1/4 mb-2"></div>
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <div className="shimmer h-3 rounded-md w-1/2"></div>
            <div className="shimmer h-3 rounded-md w-8"></div>
          </div>
        </div>
      </div>

    </div>
  );
}

// 2. STAT CARD SKELETON
export function StatCardSkeleton() {
  return (
    <div className="bg-white p-4 rounded-xl border border-border-primary flex justify-between items-center w-full">
      <div className="space-y-1.5 flex-1 text-left">
        <div className="shimmer h-3 rounded-md w-1/3"></div>
        <div className="shimmer h-6 rounded-md w-1/2"></div>
      </div>
      <div className="shimmer w-9 h-9 rounded-lg"></div>
    </div>
  );
}

// 3. TABLE ROW SKELETON (GENERIC)
export function TableRowSkeleton() {
  return (
    <tr>
      <td className="py-4 px-6"><div className="shimmer h-4 rounded-md w-16"></div></td>
      <td className="py-4 px-6"><div className="shimmer h-4 rounded-md w-24"></div></td>
      <td className="py-4 px-6"><div className="shimmer h-4 rounded-md w-32"></div></td>
      <td className="py-4 px-6"><div className="shimmer h-4 rounded-md w-12"></div></td>
      <td className="py-4 px-6"><div className="shimmer h-4 rounded-md w-24"></div></td>
      <td className="py-4 px-6"><div className="shimmer h-4 rounded-full w-16"></div></td>
      <td className="py-4 px-6 text-right"><div className="shimmer h-4 rounded-md w-20 ml-auto"></div></td>
    </tr>
  );
}

// 4. ORDERS TABLE SKELETON
export function OrdersTableSkeleton({ isHistoryView = false, isUpcomingTable = false, rows = 3 }) {
  return (
    <div className="w-full">
      <div className="w-full overflow-x-auto bg-white rounded-xl border border-border-primary shadow-xs">
        <table className="w-full text-left border-separate border-spacing-0">
          <thead>
            <tr className="bg-bg-secondary text-[11px] uppercase tracking-wider font-bold text-text-secondary">
              <th className="py-4 px-6 border-b border-border-primary">Order ID</th>
              <th className="py-4 px-6 border-b border-border-primary">Meal</th>
              {isHistoryView && <th className="py-4 px-6 border-b border-border-primary">Date</th>}
              <th className="py-4 px-6 border-b border-border-primary">Time / Category</th>
              {isUpcomingTable && <th className="py-4 px-6 border-b border-border-primary">Cutoff Timer</th>}
              <th className="py-4 px-6 border-b border-border-primary text-center">Qty</th>
              <th className="py-4 px-6 border-b border-border-primary">Total</th>
              <th className="py-4 px-6 border-b border-border-primary">Status</th>
              <th className="py-4 px-6 border-b border-border-primary text-right">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border-primary bg-white">
            {Array.from({ length: rows }).map((_, idx) => (
              <tr key={idx}>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-16 rounded font-mono"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="space-y-1.5 text-left">
                    <div className="shimmer h-4 w-36 rounded"></div>
                    <div className="shimmer h-3 w-24 rounded"></div>
                  </div>
                </td>
                {isHistoryView && (
                  <td className="py-4 px-6 border-b border-border-primary/60">
                    <div className="shimmer h-3.5 w-20 rounded font-mono"></div>
                  </td>
                )}
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-3.5 w-16 rounded"></div>
                </td>
                {isUpcomingTable && (
                  <td className="py-4 px-6 border-b border-border-primary/60">
                    <div className="shimmer h-5 w-20 rounded-md"></div>
                  </td>
                )}
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-8 rounded mx-auto"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-14 rounded"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-6 w-20 rounded-full"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60 text-right">
                  <div className="flex justify-end gap-2">
                    <div className="shimmer h-7 w-7 rounded-lg"></div>
                    <div className="shimmer h-7 w-7 rounded-lg"></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// 5. INVOICE TABLE SKELETON
export function InvoiceTableSkeleton({ rows = 4 }) {
  return (
    <div className="w-full">
      <div className="w-full overflow-x-auto bg-white rounded-xl border border-border-primary shadow-xs">
        <table className="w-full text-left border-separate border-spacing-0">
          <thead>
            <tr className="bg-bg-secondary text-[11px] uppercase tracking-wider font-bold text-text-secondary">
              <th className="py-4 px-6 border-b border-border-primary">Invoice ID</th>
              <th className="py-4 px-6 border-b border-border-primary">Date</th>
              <th className="py-4 px-6 border-b border-border-primary">Order Details</th>
              <th className="py-4 px-6 border-b border-border-primary">Amount</th>
              <th className="py-4 px-6 border-b border-border-primary">Payment Method</th>
              <th className="py-4 px-6 border-b border-border-primary">Status</th>
              <th className="py-4 px-6 border-b border-border-primary text-right">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border-primary bg-white">
            {Array.from({ length: rows }).map((_, idx) => (
              <tr key={idx}>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-20 rounded font-mono"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-3.5 w-24 rounded font-mono"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-40 rounded"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-16 rounded font-mono"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60 text-text-secondary">
                  <div className="shimmer h-4 w-24 rounded"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-6 w-16 rounded-full"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60 text-right">
                  <div className="flex justify-end gap-3">
                    <div className="shimmer h-7 w-7 rounded-lg"></div>
                    <div className="shimmer h-7 w-7 rounded-lg"></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// 6. SUBSCRIPTIONS TABLE SKELETON
export function SubscriptionsTableSkeleton({ rows = 4 }) {
  return (
    <div className="w-full">
      <div className="w-full overflow-x-auto bg-white rounded-xl border border-border-primary shadow-xs">
        <table className="w-full text-left border-separate border-spacing-0">
          <thead>
            <tr className="bg-bg-secondary text-[11px] uppercase tracking-wider font-bold text-text-secondary">
              <th className="py-4 px-6 border-b border-border-primary">Plan ID</th>
              <th className="py-4 px-6 border-b border-border-primary">Meal Name</th>
              <th className="py-4 px-6 border-b border-border-primary">Type</th>
              <th className="py-4 px-6 border-b border-border-primary">Billing & Slot</th>
              <th className="py-4 px-6 border-b border-border-primary">Consumed</th>
              <th className="py-4 px-6 border-b border-border-primary">Status</th>
              <th className="py-4 px-6 border-b border-border-primary text-center">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border-primary bg-white">
            {Array.from({ length: rows }).map((_, idx) => (
              <tr key={idx}>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-20 rounded font-mono"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-4 w-32 rounded font-bold"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-5 w-14 rounded"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60 text-text-secondary">
                  <div className="space-y-1">
                    <div className="shimmer h-3.5 w-24 rounded"></div>
                    <div className="shimmer h-3 w-16 rounded"></div>
                  </div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60 text-text-primary font-mono">
                  <div className="shimmer h-4 w-12 rounded"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60">
                  <div className="shimmer h-6 w-16 rounded-full"></div>
                </td>
                <td className="py-4 px-6 border-b border-border-primary/60 text-center font-medium">
                  <div className="flex justify-center">
                    <div className="shimmer h-7 w-7 rounded-lg"></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// 7. CUSTOMER PROVIDER CARD SKELETON
export function ProviderCardSkeleton() {
  return (
    <div className="bg-white border border-border-primary/80 rounded-2xl p-4 sm:p-5 flex flex-col lg:flex-row gap-6 mb-6 shadow-2xs w-full overflow-hidden">
      
      {/* Left Side: Provider Details Shimmer */}
      <div className="flex-[1.4] w-full flex flex-col sm:flex-row justify-between items-start gap-4">
        <div className="flex gap-4 items-start w-full">
          {/* Logo box */}
          <div className="shimmer w-14 h-14 rounded-xl shrink-0"></div>
          
          <div className="space-y-2.5 flex-1 text-left">
            <div className="flex flex-wrap items-center gap-2">
              <div className="shimmer h-5 w-40 rounded"></div>
              <div className="shimmer h-5 w-12 rounded"></div>
              <div className="shimmer h-5 w-16 rounded"></div>
            </div>
            
            <div className="shimmer h-4 w-32 rounded"></div>
            <div className="shimmer h-3.5 w-48 rounded"></div>
            <div className="shimmer h-3 w-64 rounded"></div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-2 mt-3 sm:mt-0 pt-3 sm:pt-0 border-t sm:border-t-0 border-border-primary/40 shrink-0 w-full sm:w-auto">
          <div className="shimmer h-7 w-24 rounded-lg"></div>
          <div className="shimmer h-7 w-16 rounded-lg"></div>
        </div>
      </div>

      <div className="hidden lg:block w-[1px] bg-border-primary/80 self-stretch my-1" />
      <div className="block lg:hidden h-[1px] bg-border-primary/80 w-full" />

      {/* Right Side: Customer Details & Balance Shimmer */}
      <div className="flex-1 w-full flex flex-col sm:flex-row gap-4 items-start justify-between">
        <div className="flex gap-3 text-left w-full sm:w-auto">
          <div className="shimmer w-11 h-11 rounded-xl shrink-0"></div>
          <div className="space-y-2 flex-1">
            <div className="flex items-center gap-2">
              <div className="shimmer h-4.5 w-36 rounded"></div>
              <div className="shimmer h-4.5 w-16 rounded"></div>
            </div>
            <div className="space-y-1.5">
              <div className="shimmer h-3 w-40 rounded"></div>
              <div className="shimmer h-3 w-28 rounded"></div>
            </div>
          </div>
        </div>

        {/* Balance Card */}
        <div className="w-full sm:w-auto p-3.5 rounded-xl border border-border-primary/80 bg-bg-secondary/20 flex sm:flex-col items-center sm:items-end justify-between gap-3 sm:gap-2 shrink-0">
          <div className="shimmer h-3.5 w-24 rounded"></div>
          <div className="shimmer h-6 w-20 rounded"></div>
        </div>
      </div>
    </div>
  );
}

// 8. FULL PAGE PORTAL SKELETON
export function PageSkeleton() {
  return (
    <div className="w-full flex flex-col overflow-hidden">
      {/* Provider Details Shimmer */}
      <ProviderCardSkeleton />

      {/* Tab Navigation Shimmer */}
      <div className="flex border-b border-border-primary mb-6 gap-6 sm:gap-8 px-2 w-full overflow-hidden">
        {Array.from({ length: 4 }).map((_, idx) => (
          <div key={idx} className="py-3 px-1">
            <div className="shimmer h-5 w-24 rounded"></div>
          </div>
        ))}
      </div>

      {/* Active Tab Content (Today's Orders Outline) */}
      <div className="space-y-6 flex-1 overflow-hidden">
        <div className="flex justify-between items-center gap-4">
          <div className="space-y-1.5 text-left">
            <div className="shimmer h-6 w-40 rounded"></div>
            <div className="shimmer h-3 w-64 rounded"></div>
          </div>
          <div className="shimmer h-9 w-28 rounded-lg"></div>
        </div>

        {/* Toolbar Shimmer */}
        <div className="flex flex-col sm:flex-row gap-4 justify-between items-center bg-bg-secondary/40 p-3 rounded-xl border border-border-primary/60">
          <div className="shimmer h-9 w-full sm:w-64 rounded-lg"></div>
          <div className="flex gap-2 w-full sm:w-auto justify-end">
            <div className="shimmer h-9 w-20 rounded-lg"></div>
            <div className="shimmer h-9 w-20 rounded-lg"></div>
          </div>
        </div>

        {/* Upcoming Orders Section Header */}
        <div className="space-y-3">
          <div className="shimmer h-3.5 w-32 rounded"></div>
          {/* Table Shimmer */}
          <OrdersTableSkeleton isHistoryView={false} isUpcomingTable={true} rows={2} />
        </div>
      </div>
    </div>
  );
}
